// Browser Notifications API
// https://developer.mozilla.org/en-US/docs/Web/API/Notification
function _requestPermissionAndSend(notification) {
  if (!Notification || Notification.permission !== 'default') {
    return;
  }

  Notification.requestPermission((permission) => {
    if (!('permission' in Notification)) {
      Notification.permission = permission;
    }

    if (!notification) {
      return;
    }

    _sendNotification(notification);
  });
};

function _sendNotification(notification) {
  const browserNotification = new Notification(notification.pageTitle, {
    body: notification.body,
    data: notification.data,
    icon: notification.icon,
    tag: notification.tag,
  });

  browserNotification.onclick = (ev) => {
    ev.preventDefault();

    const notification = ev.target;
    notification.close();

    if (!notification.data || !notification.data.url) {
      parent.focus();
      window.focus();
      return;
    }

    window.open(notification.data.url, '_blank');
  };

  if (typeof notification.timeoutMs !== 'number') {
    return;
  }

  setTimeout(browserNotification.close.bind(browserNotification), notification.timeoutMs);
};

class DuiDesktopNotificationManager {
  send(notificationInfo) {
    if (!Notification || Notification.permission === 'denied') {
      return;
    }

    const notification = {
      body: notificationInfo.body,
      data: notificationInfo.data,
      icon: notificationInfo.icon,
      pageTitle: notificationInfo.pageTitle,
      tag: notificationInfo.tag,
      timeoutMs: notificationInfo.timeoutMs,
    };

    if (Notification.permission === 'granted') {
      _sendNotification(notification);
      return;
    }

    _requestPermissionAndSend(notification);
  };
}

export default {
  install: function(Vue) {
    Vue.duiDesktopNotificationManager = new DuiDesktopNotificationManager();
  },
};
